

export class UserSelectByIdOutputDataVehicleGroupData implements IUserSelectByIdOutputDataVehicleGroupData {
    /** The auto-generated id of the vehicle */
    vehicle_group_id!: number;

    constructor(data?: IUserSelectByIdOutputDataVehicleGroupData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_group_id = _data["vehicle_group_id"];
        }
    }

    static fromJS(data: any): UserSelectByIdOutputDataVehicleGroupData {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectByIdOutputDataVehicleGroupData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_group_id"] = this.vehicle_group_id;
        return data; 
    }
}

export interface IUserSelectByIdOutputDataVehicleGroupData {
    /** The auto-generated id of the vehicle */
    vehicle_group_id: number;
}

